import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import starIcon from "../../../../../assets/svg/starAbout2.svg";
import calendarIcon from "../../../../../assets/svg/calendarCohort.svg";
import privateCohortBtn from "../../../../../assets/svg/shield2.svg";
import AnimeList from "../ViewAllMentorList/AnimeList";
import MentorIcon from "../../../../../assets/svg/dashboard/Mentor-iconCircle.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import axios from "axios";
import "./style.scss";
import {
  COHORT_NAME_LIST,
  ORGANIZATION_NAME_LIST,
  ADMIN_DASHBOARD_SPOTLIGHT_CALENDAR,
} from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import StartupIcon from "../../../../../assets/svg/dashboard/StartupIcon-Circle.svg";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import { Country, State, City } from "country-state-city";
import ChatBoxModal from "../../../../common/chatBoxModal";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import mentorshipIcon from "../../../../../assets/svg/cohortMeeting.svg";
import { getCohortStartupList } from "../dependencies/action";
import { postCounterStartupCohort } from "../../MentorDashboard/dependencies/action";
import ModalFilter2 from "../../../../common/modalFilter2";
const CohortStartupRequest = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const {
    getCohortStartupList,
    getListData,
    postCounterStartupCohort,
    tableCounterData,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [activeText, setActiveText] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [intentToMentor, setIntentToMentor] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);

  const [filterNameValue, setFilterNameValue] = useState("");
  const [filterCohortname, setFilterCohortname] = useState("");
  const [filterOrgname, setFilterOrgname] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [orgnameList, setorgnameList] = useState([]);
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const ViewApplicationCohort = (item) => {
    let reRoute = window.open(`/view-CohortApplication/${item}`, "_blank");
    reRoute.id = item;

    reRoute.fromModule = "ViewApplicationCohort";
  };
  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [mentorRequest, setMentorRequest] = useState();
  const [mentorRequestId, setMentorRequestId] = useState();
  const [modalVisibility2, setModalVisibility2] = useState();
  const [dataID, setDataID] = useState();

  useEffect(() => {
    html.style.overflow = "auto";

    localStorage.setItem("CohortStartupRequest", "CohortStartupRequest");

    setTimeout(() => {
      localStorage.removeItem("myRequests");
      localStorage.removeItem("startupAllMentorList");
      localStorage.removeItem("mentorStartupRequest");
      localStorage.removeItem("startUpRequests");
      localStorage.removeItem("cohortMentorshipsStartup");
    }, 1000);
    let params = {
      startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      forStartup: true,
    };
    postCounterStartupCohort(params);
  }, []);

  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
  } = props;
  useEffect(() => {
    // getAllData()
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     startupId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        startupId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: item.name,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameList.length)
              setcohortnameList((oldArray) => [...oldArray, arr]);
          });
      })
      .catch((err) => {});

    // axios({
    //   url: ORGANIZATION_NAME_LIST,
    //   method: "post",
    //   data: {
    //     startupId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(ORGANIZATION_NAME_LIST, {
        startupId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Organisation Name",
                value: "select",
              };
              setorgnameList((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: item.name,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameList.length)
              setorgnameList((oldArray) => [...oldArray, arr]);
          });
      })
      .catch((err) => {});
  }, []);
  const getTableDataStatus2 = (status) => {
    let params = {
      cohortId: "",
      cohortApplicationId: filterCohortname == "select" ? "" : filterCohortname,
      organization_name: filterOrgname == "select" ? "" : filterOrgname,
      startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      requestStatus: selectedStatus,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 9,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      fromStartup: true,
    };

    getCohortStartupList(params);
  };
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  useEffect(() => {
    if (props?.location?.state?.requestStatus === undefined) {
      setActiveText(true);
    } else if (props?.location?.state?.requestStatus === "pending") {
      setActiveText2(true);
    } else if (props.location.state.requestStatus === "viewAll") {
      setActiveText(true);
    } else setActiveText(true);
  }, []);
  useEffect(() => {
    let params = {
      cohortId: filterCohortname == "select" ? "" : filterCohortname,
      organization_name: filterOrgname == "select" ? "" : filterOrgname,
      startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      // industry: filterIndustry ? filterIndustry : null,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      // function: filterFunction ? filterFunction : null,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      // stage: filterStage ? filterStage : null,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      requestStatus: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 9,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      fromStartup: true,
    };

    getCohortStartupList(params);
  }, [cohortfilterGo]);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  const getTableList = (status) => {
    let params = {
      // cohortId: filterCohortname,
      cohortId: filterCohortname == "select" ? "" : filterCohortname,
      organization_name: filterOrgname == "select" ? "" : filterOrgname,
      startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      // industry: filterIndustry ? filterIndustry : null,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      // function: filterFunction ? filterFunction : null,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      // stage: filterStage ? filterStage : null,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      requestStatus: status,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 9,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      fromStartup: true,
    };

    getCohortStartupList(params);
  };

  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      requestedBy: "",
      status: selectedStatus,
      pageFilter: {
        currentPage: pageNumber - 1,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: filterNameValue == "Select" ? "" : filterNameValue,
      searchKey: null,
      country: "",
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getCohortStartupList(params);
  };
  const testUpcomingSession = (cohortId, cohortAdminId) => {
    let cohortSession = fetchCalendarSession(cohortId);
    if (
      cohortSession !== undefined &&
      cohortSession !== null &&
      cohortSession !== ""
    ) {
      let arr = [];
      cohortSession.forEach((element) => {
        arr.push({
          date: moment(element?.sessionDate).format("YYYY/MM/DD"),
          cohortId: cohortId,
          cohortAdminId: cohortAdminId,
        });
      });
      let nearestDate;
      let nearestDate2;
      const dateToCheckFor = moment().format("YYYY/MM/DD");
      arr.forEach((element) => {
        let diff = moment(element?.date).diff(moment(dateToCheckFor), "days");
        if (diff > 0) {
          if (nearestDate) {
            if (moment(element?.date).diff(moment(nearestDate), "days") < 0) {
              nearestDate = element?.date;
              nearestDate2 = element;
            }
          } else {
            nearestDate = element?.date;
            nearestDate2 = element;
          }
        }
      });
      if (
        nearestDate !== undefined &&
        nearestDate !== null &&
        nearestDate !== ""
      ) {
        return nearestDate;
      }
    } else {
      return null;
    }
  };

  const fetchCalendarSession = (cohortID) => {
    var localTime = new Date(); // store localTime
    let localFullTime = localTime.toISOString();
    var proposedDate = localTime + "T00:00:00.000Z";
    var momentDate = moment(proposedDate);
    var endMonth = moment(localTime).add(30, "day").toDate();
    var endMonth2 = endMonth.toISOString();
    var hour = momentDate.hours();
    var minutes = momentDate.minutes();
    var seconds = momentDate.seconds();
    let paramsTest = {
      cohortId: cohortID,
      sessionStartDate: localFullTime,
      sessionEndDate: endMonth2,
    };
    api
      .POST(`${ADMIN_DASHBOARD_SPOTLIGHT_CALENDAR}`, paramsTest)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (response.data.data?.length > 0) return response.data.data;
        } else {
          return null;
        }
      })
      .catch((e) => {
        return null;
      });
  };
  return (
    <>
      <div className="maincohortpmobile">
        <div
          className="dashboard-main2 mycohortreqdiv"
          style={{ background: "none" }}
        >
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  props.setSelectedMenu("cohortApplication");
                  history.push("/dashboard");
                  // localStorage.removeItem("CohortStartupRequest");

                  // window.location.reload();
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "217px",
                  left: "71px",
                }}
              >
                Click to Go Cohort Applications
              </span>
            </div>
            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
              intentToMentor={intentToMentor}
              fromPage="Startup"
            />
            {modalVisibility2 && (
              <ModalFilter2
                modalVisibility={modalVisibility2}
                setModalVisibility={setModalVisibility2}
                // sendToParent={setIsParentData}
                showPurposeOfMentorship={true}
                fromPage={"startUpDashboard"}
                allCalendarData={true}
                particularCohort={dataID}
              />
            )}
          </div>
          <div className="iconWith-heading cohortappiconwith">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                STARTUP DASHBOARD: MY COHORT REQUESTS
              </h3>
            </div>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
              // style={{ marginTop: "-20px" }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}{" "}
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew2 row  mobileviewmentorbelow">
            <div
              className="mentorImageParent"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={mentorshipIcon} className="sidebar-dashboard-icon003" />
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
              <div className="dashboard-bottom-btn2">
                <p className="text-white2"> COHORT STATUS</p>
              </div>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  getTableList("");
                }}
                style={{
                  color: activeText ? "#277acc" : "#838186",
                }}
                className="admindasheaderoptions applicationHeading9000"
              >
                TOTAL REQUESTS :{" "}
                {tableCounterData && tableCounterData.total !== null
                  ? tableCounterData.total
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "77px", width: "210px", top: "31px" }}
              >
                Click to View Total Requests
              </span>
              {activeText ? (
                <img
                  className="requestStatusBar applicationLine9000"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("PENDING");
                  getTableList("Requested");
                }}
                style={{ color: activeText2 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading9002"
              >
                {" "}
                PENDING :{" "}
                {tableCounterData && tableCounterData.requested !== null
                  ? tableCounterData.requested
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "84px", width: "230px", top: "31px" }}
              >
                Click to View Pending Requests
              </span>
              {activeText2 ? (
                <img
                  className="requestStatusBar applicationLine9001"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2  newuserTooltip">
              <p
                onClick={() => {
                  setActiveText3(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(false);
                  getTableList("Accepted");
                  setSelectedStatus("ACCEPTED");
                }}
                style={{ color: activeText3 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading9000"
              >
                {" "}
                ACCEPTED :{" "}
                {tableCounterData && tableCounterData.accepted !== null
                  ? tableCounterData.accepted
                  : 0}
              </p>

              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "77px", width: "220px", top: "31px" }}
              >
                Click to View Accepted Requests
              </span>
              {activeText3 ? (
                <img
                  className="requestStatusBar applicationLine90020"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText3(false);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(true);
                  getTableList("Declined");
                  setSelectedStatus("REJECTED");
                }}
                style={{ color: activeText4 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading9003"
              >
                {" "}
                DECLINED :{" "}
                {tableCounterData && tableCounterData.declined !== null
                  ? tableCounterData.declined
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "77px", width: "220px", top: "31px" }}
              >
                Click to View Declined Requests
              </span>
              {activeText4 ? (
                <img
                  className="requestStatusBar applicationLine9002"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="filter-row filter-row-common filterDivMentorapp">
            <div>
              <form className="formContainer newfilterdivnow">
                <div className="row desktopFilterRow">
                  <div className="col-11 d-flex justify-content-between filter-bigDiv">
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="orgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="orgname"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.orgname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              orgname: e.value == "select" ? null : e,
                            };
                          });
                          setFilterOrgname(e.value);
                        }}
                        options={orgnameList}
                        placeholder="Organisation Name"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "180px" }}
                      >
                        Search Organisation Name
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="cohortorgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortorgname"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortorgname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortorgname: e.value == "select" ? null : e,
                            };
                          });
                          setFilterCohortname(e.value);
                        }}
                        options={cohortnameList}
                        placeholder="Cohort Name"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "150px" }}
                      >
                        Search Cohort Name
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip ">
                      <Select
                        required={true}
                        id="stage"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search State
                      </span>
                    </div>
                  </div>

                  <div className="apply-section d-flex justify-content-end col-1 newuserTooltip">
                    <Button
                      onClick={getTableDataStatus2}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn startupColorBtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="orgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="orgname"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.orgname}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            orgname: e.value == "select" ? null : e,
                          };
                        });
                        setFilterOrgname(e.value);
                      }}
                      options={orgnameList}
                      placeholder="Organisation Name"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortorgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortorgname"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortorgname}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortorgname: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortname(e.value);
                      }}
                      options={cohortnameList}
                      placeholder="Cohort Name"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>

                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      onClick={getTableDataStatus2}
                      text="GO"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Records Found : {getListData?.length} &lt; 1 of 1 &gt;{" "}
          </div>
          {/* {getListData && getListData?.length > 0 ? (
            <div className="parentRow2">
              {getListData.map((item, index) => (
                <div
                  className={
                    getListData?.length < 3 ? "childColumn2" : "childColumn"
                  }
                >
                  <div className="cohortV2Heading">{item?.sessionTitle}</div>
                  <div className="containerCohortV2">
                    <img
                      className="containerCohortV2Image"
                      src={
                        item?.cohortApplication?.uploadBanner !== undefined &&
                        item?.cohortApplication?.uploadBanner !== "" &&
                        item?.cohortApplication?.uploadBanner !== null
                          ? item?.cohortApplication?.uploadBanner
                          : hashImage
                      }
                    />
                  </div>
                  <div className="cohortV2Heading d-flex">
                  {item?.cohortApplication?.program_name?.length > 30 ? (
                                  <div className="tooltipicon">
                                  {item?.cohortApplication?.program_name.slice(0, 30)}
                                  <b style={{ cursor: "pointer" }}>...</b>
                                  <span className="tooltiptext7" style={{ top: "-8rem",position:"absolute"}}>
                                    <h5 style={{ color: "#fff",whiteSpace:"nowrap" }}>COHORT PROGRAM TITLE</h5>
                                    {item?.cohortApplication?.program_name}
                                  </span>
                                </div>
                                  ) : (
                                    item?.cohortApplication?.program_name
                                  )}                  </div>
                  <div className="cohortV2Footer">
                    {item?.cohortApplication?.spotlight !== undefined &&
                      item?.cohortApplication?.spotlight !== "" &&
                      item?.cohortApplication?.spotlight !== null &&
                      item?.cohortApplication?.spotlight && (
                        <div className="cohortV2FooterIcon">
                          <img src={starIcon} />
                        </div>
                      )}
                    <div className="cohortV2FooterIcon">
                      <img src={privateCohortBtn} />
                    </div>

                    <div>
                      <div
                        className={
                          item?.requestStatus == "Accepted"
                            ? "d-flex newAboutExitBtn newuserTooltip"
                            : "d-flex newAboutExitBtnDisabled"
                        }
                        onClick={() => {
                          if (item?.requestStatus == "Accepted")
                            window.open(
                              `/cohort-programs/cohortView/${item?.cohortApplication?.id}`,
                              "_blank"
                            );
                        }}
                      >
                        {" "}
                        {item?.requestStatus == "Accepted"
                          ? "View"
                          : item?.requestStatus == "Requested"
                          ? "Request Sent"
                          : item?.requestStatus == "Declined" &&
                            "Request Declined"}
                        {item?.requestStatus == "Accepted" && (
                          <span
                            className="tooltiptext tooltip-bottom "
                            style={{
                              left: "2rem",
                              top: "3rem",
                              width: "150px",
                            }}
                          >
                            View Cohort Details
                          </span>
                        )}
                      </div>
                    </div>
                    <div
                      className="cohortV2FooterIcon newuserTooltip"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setDataID(item?.cohortId);
                        setModalVisibility2(true);
                      }}
                    >
                      <img src={calendarIcon} />
                      <span
                        className="tooltiptext   tooltip-bottom"
                        style={{
                          left: "8px",
                          width: "160px",
                          height: "30px",
                          top: "4rem",
                        }}
                      >
                        Click to View Sessions
                      </span>
                    </div>
                    <div></div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            "No Record Found"
          )} */}
          {getListData && getListData?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth4"
                      >
                        {" "}
                        <div>NO.</div>
                      </th>
                      <th
                        className="fixColumbnWidth"
                        colspan="2"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",

                            minWidth: "9.9rem",
                            maxWidth: "10rem",
                          }}
                        >
                          COHORT DETAILS
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth4"
                        style={{
                          whitespace: "nowrap",
                          fontSize: "15.3px",
                          verticalAlign: "middle",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",

                            minWidth: "8.4rem",
                            maxWidth: "8.5rem",
                          }}
                        >
                          REQUEST ID
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth4"
                        style={{ fontSize: "15.3px", verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",

                            minWidth: "8.4rem",
                            maxWidth: "8.5rem",
                          }}
                        >
                          REQUEST STATUS
                        </div>
                      </th>

                      <th
                        className="fixColumbnWidth4"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          SEND MESSAGE
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {getListData &&
                      getListData.map((item, index) => (
                        <tr
                          key={index}
                          className={
                            item.requestId === indexCounter
                              ? "purpleBackground"
                              : ""
                          }
                        >
                          <td>
                            <div>{index + 1}</div>
                          </td>

                          <td
                            className="hidedetd"
                            style={
                              {
                                // display: "flex",
                                // justifyContent: "center",
                              }
                            }
                          >
                            <div
                              className="newuserTooltip rightsideformb"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={
                                  item.cohortApplication.uploadBanner === null
                                    ? hashImage
                                    : item.cohortApplication.uploadBanner
                                }
                                onClick={() =>
                                  window.open(
                                    `/cohort-programs/all/${item?.cohortApplication.id}`,
                                    "_blank"
                                  )
                                }
                                className="sidebar-dashboard-icon2"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "46px",
                                  width: "150px",
                                  top: "88px",
                                }}
                              >
                                View Cohort Details
                              </span>
                              <div
                                className="hidedata2"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  maxWidth: "240px",
                                }}
                              >
                                <div className="newuserTooltip">
                                  <a
                                    onClick={() => {
                                      ViewApplicationCohort(
                                        item.cohortApplication.id
                                      );
                                    }}
                                    className="color-green"
                                  >
                                    {item.cohortApplication.cohortId !== null &&
                                      item.cohortApplication.cohortId !== "" &&
                                      "C" +
                                        item?.cohortApplication?.cohortId?.substring(
                                          item.cohortApplication.cohortId
                                            .length - 6
                                        )}
                                  </a>
                                  <span
                                    className="tooltiptext mentoricon tooltip-bottom"
                                    style={{ width: "12.5vw" }}
                                  >
                                    View Cohort Application
                                  </span>
                                </div>
                                {item.cohortApplication.program_name}
                                <br></br>
                                {item.cohortApplication.organization_name}
                                <br></br>
                                Start Date:{" "}
                                {moment(item?.cohort_date).format("DD/MM/YYYY")}
                                <br></br>
                                Duration:{" "}
                                {item.cohortApplication.program_duration}
                                <br></br>
                                <div
                                  className="d-flex justify-content-end newuserTooltip "
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "end",
                                    justifyContent: "center",

                                    minWidth: "40px",
                                    display: "flex",
                                  }}
                                >
                                  <img
                                    src={StartupIcon}
                                    width={40}
                                    onClick={() =>
                                      window.open(
                                        `/cohort-programs/all/${item?.cohortApplication.id}`,
                                        "_blank"
                                      )
                                    }
                                  />

                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "-60px",
                                      top: "105px",
                                      width: "150px",
                                    }}
                                  >
                                    View Cohort Details
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="hideformb">
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                                height: "auto",
                                alignItems: "end",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  maxWidth: "240px",
                                  minWidth: "240px",
                                }}
                              >
                                <div className="newuserTooltip">
                                  <a
                                    onClick={() => {
                                      ViewApplicationCohort(
                                        item.cohortApplication.id
                                      );
                                    }}
                                    className="color-green"
                                  >
                                    {item.cohortApplication.cohortId !== null &&
                                      item.cohortApplication.cohortId !== "" &&
                                      "C" +
                                        item?.cohortApplication?.cohortId?.substring(
                                          item.cohortApplication.cohortId
                                            .length - 6
                                        )}
                                  </a>
                                  <span
                                    className="tooltiptext mentoricon tooltip-bottom"
                                    style={{ width: "12.5vw" }}
                                  >
                                    View Cohort Application
                                  </span>
                                </div>
                                {item.cohortApplication.program_name}
                                <br></br>
                                {item.cohortApplication.organization_name}
                                <br></br>
                                Start Date:{" "}
                                {moment(item?.cohort_date).format("DD/MM/YYYY")}
                                <br></br>
                                Duration:{" "}
                                {item.cohortApplication.program_duration}
                                <br></br>
                              </div>
                              <div
                                className="d-flex justify-content-end newuserTooltip"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  height: "100px",
                                  minWidth: "40px",
                                  display: "flex",
                                }}
                              >
                                <img
                                  src={StartupIcon}
                                  width={40}
                                  onClick={() =>
                                    window.open(
                                      `/cohort-programs/all/${item?.cohortApplication.id}`,
                                      "_blank"
                                    )
                                  }
                                />

                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "17px",
                                    top: "105px",
                                    width: "150px",
                                  }}
                                >
                                  View Cohort Details
                                </span>
                              </div>
                            </div>
                          </td>

                          <td className="matchList-tooltip">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <div className="newuserTooltip">
                                  <a
                                    onClick={() => {
                                      setIntentToMentor(item.intentToMentor);
                                      setModalData(item.requestJson);
                                      setModalOpen(true);
                                    }}
                                    className="color-green "
                                  >
                                    {item?.id !== null &&
                                      item?.id !== "" &&
                                      "S" +
                                        item?.id?.substring(
                                          item?.id?.length - 6
                                        )}
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={{
                                        top: "30px",
                                        left: "40px",
                                        width: "130px",
                                      }}
                                    >
                                      View Requirement
                                    </span>
                                  </a>
                                </div>

                                <div>
                                  {item.dateApplied &&
                                    item.dateApplied !== null &&
                                    item.dateApplied !== "" &&
                                    moment(item.dateApplied).format(
                                      "DD/MM/YYYY"
                                    )}
                                  <br></br>
                                  {item.dateApplied &&
                                    item.dateApplied !== null &&
                                    item.dateApplied !== "" &&
                                    moment(item.dateApplied).format("hh:mm A")}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                // fontSize: "16px",
                                alignItems: "center",

                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.requestStatus}
                              <br></br>
                              {item.dateUpdated &&
                              item.dateUpdated !== null &&
                              item.dateUpdated !== ""
                                ? moment(item.dateUpdated).format("DD/MM/YYYY")
                                : ""}
                              <br />
                              {item.dateUpdated &&
                              item.dateUpdated !== null &&
                              item.dateUpdated !== ""
                                ? moment(item.dateUpdated).format("hh:mm A")
                                : ""}
                            </div>
                          </td>

                          <td className="semmsg">
                            <div
                              className="d-flex  newuserTooltip"
                              style={{
                                cursor: "pointer",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100px",
                                width: "40px",
                                display: "flex",
                              }}
                            >
                              <img
                                src={buttonSendMessage}
                                onClick={() => {
                                  setChatBoxModalOpen(true);
                                  let params = {
                                    mentorName:
                                      item.cohortApplication.program_name,
                                  };
                                  setMentorRequest(params);
                                  setMentorRequestId(item.cohortAdminId);
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom tooltipmsg"
                                style={{
                                  top: "80px",
                                  left: "15px",
                                  width: "120px",
                                }}
                              >
                                Send Message
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                  <ChatBoxModal
                    modalVisibility={chatBoxModalOpen}
                    setModalVisibility={setChatBoxModalOpen}
                    receiverInfo={mentorRequest}
                    receiverId={mentorRequestId}
                  />
                </table>
                <div className="pagination-box">
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={10}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange.bind(this)}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}

          {/* <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn newuserTooltip"
            style={{ margin: "auto" }}
          
          >
            <p style={{ cursor: "pointer" }} className="text-white3">
              COHORT MENTORSHIPS
            </p>
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "400px", top: "60px", width: "230px" }}
            >
              Click to View Cohort Mentorships
            </span>
          </div> */}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getListData: state.StartUpReducer.getCohortForStartupList.data,
    tableCounterData:
      state.MentorReducer.getStartupCohortMentorModuleCounter.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getCohortStartupList,
  postCounterStartupCohort,
  getStepperTooltipData,
})(withRouter(CohortStartupRequest));
